import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { DropdownModule } from '../dropdown';
import { IconsModule } from '../icons';
import { TabSelectableModule } from '../tab-selectable';
import { LanguageChooserComponent } from './language-chooser.component';

@NgModule({
  declarations: [LanguageChooserComponent],
  imports: [CommonModule, DropdownModule, IconsModule, MatomoTrackClickDirective, TabSelectableModule],
  exports: [LanguageChooserComponent]
})
export class LanguageChooserModule {}
